import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { db } from "../../firebase"; // Firestore
import { doc, setDoc, getDoc, updateDoc } from "firebase/firestore"; // Firestore methods
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CircularProgress } from '@mui/material';
import './PaymentPage.css'
import QRimg from '../../assets/qr-img.jpg'
import UPID from '../../assets/UPID.jpg'
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from '@mui/material';
import { Margin } from "@mui/icons-material";

const PaymentPage = () => {
  const location = useLocation();
  const { registrationData,certificateImages, username, amount } = location.state || {}; // Receiving registration data and username via props
  const [loading, setLoading] = useState();
  const [open, setOpen] = useState(true);
  const [Register ,setRegister]=useState(0);
  const [isChecked, setIsChecked] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({
    transactionId: "",
    paymentDate: "",
    amount: "",
  });

  const Navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentDetails({ ...paymentDetails, [name]: value });
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();

    const { transactionId, paymentDate, amount } = paymentDetails;
    if (!transactionId || !paymentDate || !amount) {
      toast.error("Please fill out all payment details.");
      return;
    }
    setLoading(true);
    try {
      // Step 1: Fetch the last used unique ID from the "counters" document in Firestore
      const counterDocRef = doc(db, "counters", "userIdCounter");
      const counterDoc = await getDoc(counterDocRef);

      let lastUsedId = 1; // Initialize with GP0001 if counter doesn't exist
      if (counterDoc.exists()) {
        lastUsedId = counterDoc.data().lastUsedId;
      }

      // Step 2: Generate the new unique ID
      const newUniqueId = `GP${String(lastUsedId).padStart(4, "0")}`;

      // Step 3: Save the payment details and user data with the new unique ID
      await setDoc(doc(db, "users", username), {
        username,
        registrationData,
        certificateImages,
        paymentDetails,
        uniqueId: newUniqueId, // Save the generated unique ID
      }, { merge: true, });

      // Step 4: Update the "lastUsedId" in the "counters" document for the next user
      await updateDoc(counterDocRef, { lastUsedId: lastUsedId + 1 });

      toast.success("Payment submitted successfully!");
      Navigate("/confirmation", { state: { uniqueId: newUniqueId } });

    } catch (error) {
      toast.error("Error submitting payment: " + error.message);
    }
    finally {
      setLoading(false);
    }
  };

  const handleAlreadyRegistered=  () => {
    setRegister(1000);
    setOpen(false);
    setPaymentDetails((prevDetails) => ({
      ...prevDetails,
      amount: 1000,
    }));
 };

 const handleNotRegistered = () => {
   setRegister(1500);
   setOpen(false);
   setPaymentDetails((prevDetails) => ({
    ...prevDetails,
    amount: 1500,
  }));
 };

 const handleClose = (event, reason) => {
  if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
    setOpen(false);
  }
};

const handleCheckboxChange = () => {
  setIsChecked(!isChecked);
};
//  useState({
//     setOpen(true);
//  },[])
  return (
  <div>

    
<Dialog open={open} onClose={handleClose}>
        <DialogTitle>Registration Status</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Have you already registered with a payment of 500 Rs?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAlreadyRegistered} color="primary">
            Already Registered
          </Button>
          <Button onClick={handleNotRegistered} color="secondary">
            Not Registered
          </Button>
        </DialogActions>
      </Dialog>
    <div className="payment-page">
      <ToastContainer />
      <div className="payment-container">
        <h2 className="title">Complete Your Payment </h2>
        <p className="title">Pay ₹{Register} </p>
        <div className="payment-body">
          <div className="payment-methods">
            <div className="qr-code-container">
              <img src={QRimg} alt="QR Code" draggable="false" oncontextmenu="return false "/>
              <p>Scan the QR Code</p>
            </div>

            {/* <div className="bank-details">
              <h3>Bank Account Details</h3>
              <p>Bank Name: XYZ Bank</p>
              <p>Account Number: 1234567890</p>
              <p>IFSC Code: XYZB0001234</p>
            </div> */}
             <div className=" bank-details ">
              <img src={UPID} alt="QR Code"  width={"50%"} draggable="false" oncontextmenu="return false " />
              
            </div>
          </div>
               
          <form onSubmit={handlePaymentSubmit} className="payment-form">
          <div className="form-group" style={{ width: '93%' }}>
              {/* <label>Amount</label> */}
              {/* <input
                type="number"
                name="amount"
                value={paymentDetails.amount}
                onChange={handleInputChange}
                required
                className="form-input"
                placeholder="Enter Amount"
              /> */}
              <center>Please enter the payment details.</center>
            </div>
            <div className="payment-form-container">
             
              <div className="form-group">
                <label>Transaction ID</label>
                <input
                  type="text"
                  name="transactionId"
                  value={paymentDetails.transactionId}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                  placeholder="Enter Transaction ID"
                  style={{ backgroundColor: 'white' }}
                />
              </div>
              <div className="form-group" >
                <label>Payment Date</label>
                <input
                  type="date"
                  name="paymentDate"
                  value={paymentDetails.paymentDate}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                  style={{ backgroundColor: 'white' }}
                />
              </div>
            </div>
            <div className="form-checkbox">
        <label>
          <input
            type="checkbox"
            checked={isChecked}
            onChange={handleCheckboxChange}
            className="checkbox"
          />
          I confirm that the details provided are correct and true.
        </label>
      </div>
            <div className="form-buttons">
              <button type="submit" className="submit-button"
               disabled={!isChecked }>
                {loading ? <CircularProgress size={24} /> : 'Proceed to Pay'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </div>
  );
};

export default PaymentPage;
